import { useApp } from '../../lib/app';

/** Lapsed / expired-trial notice. Drivers are told to contact their manager; the owner sees billing. */
export function StatusBanner() {
  const app = useApp();
  if (app.active || app.mode === 'local') return null;
  return (
    <div className="banner" role="status">
      {app.role === 'owner'
        ? <>Your RouteBack subscription isn't active, so everything is read-only. Subscribe from the RouteBack app on your phone to turn editing back on.</>
        : <>{app.details.name}'s RouteBack subscription isn't active right now, so you can look but not submit. Let your manager know.</>}
    </div>
  );
}
